module.exports = "/assets/data/4a5a606170830bfdfec21fc3b1a601aa-SW11.data.json";